import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

export const parseISODurationFilter = (value) => {
	if (!value) return null;

	if (
		typeof value === 'object' &&
		value.text !== undefined &&
		value.text !== ''
	) {
		return {
			text: String(value.text),
			unit: value.unit,
		};
	}

	if (typeof value !== 'string' || !value.startsWith('P')) {
		return null;
	}

	const weekMatch = value.match(/^P(\d+)W$/);

	if (weekMatch) {
		return { text: weekMatch[1], unit: 'weeks' };
	}

	const d = dayjs.duration(value);
	const days = d.asDays();
	const hours = d.asHours();
	const minutes = d.asMinutes();
	const seconds = d.asSeconds();

	if (Number.isInteger(days) && days > 0) {
		return { text: String(days), unit: 'days' };
	}

	if (Number.isInteger(hours) && hours > 0) {
		return { text: String(hours), unit: 'hours' };
	}

	if (Number.isInteger(minutes) && minutes > 0) {
		return { text: String(minutes), unit: 'minutes' };
	}

	if (seconds > 0) {
		return { text: String(seconds), unit: 'seconds' };
	}

	return null;
};

export const isISODurationFilterValue = (value) => {
	if (!value) return false;

	if (parseISODurationFilter(value)) return true;

	return typeof value === 'string' && /^P/.test(value);
};
